/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import * as zod from "zod";

/**
 * @summary 업체 직접 계약 — 씨마켓 카드결제 가능 여부
 */
export const paymentControllerGetVendorDirectEligibilityQueryParams = zod
  .object({
    quoteResponseVersionId: zod.coerce.string(),
  })
  .strict();

export const paymentControllerGetVendorDirectEligibilityResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        paymentFlow: zod
          .enum(["SEMO_ESCROW", "CONTRACT_FIRST"])
          .describe(
            "이 견적의 대금이 흐르는 길. **화면이 어느 버튼·어느 창을 띄울지 이 값 하나로 정한다.**\n\n- `SEMO_ESCROW`: 세모 안심결제. 발주기관이 먼저 결제하고, 승인되면 계약이 선다.\n- `CONTRACT_FIRST`: 계약이 먼저 서고, 결제·계산서는 씨마켓에서 한다.\n\n아래 `cardSelectable`·`cardPaymentAvailable` 은 `CONTRACT_FIRST` 일 때만 뜻이 있다 — 씨마켓 결제창에 대한 답이기 때문이다.",
          ),
        cardPaymentAvailable: zod
          .boolean()
          .describe(
            "**씨마켓 결제창**을 열 수 있는가(공급기업이 카드결제 가맹인가). false 여도 카드를 고를 수는 있다 — 그 경우 발주기관이 공급기업과 직접 카드로 결제한다. 카드 노출 여부는 이 값이 아니라 `cardSelectable` 로 정할 것.",
          ),
        cardSelectable: zod
          .boolean()
          .describe(
            "카드를 결제수단으로 **고를 수 있는가**(발주기관이 씨마켓 회원인가). 씨마켓 회원과 일반 세모 회원은 구매 로직이 갈리므로, 미연동 발주기관에게는 카드 축이 없다.",
          ),
        reason: zod
          .string()
          .nullable()
          .describe(
            "불가 사유(사용자 안내 문구). 사유를 밝힐 필요가 없는 경우(연동 미설정 등)는 null.",
          ),
        requestedPaymentChannel: zod
          .enum(["card", "cash", "undecided"])
          .nullable()
          .describe(
            "공고에서 고른 희망 결제수단(card/cash/undecided). 계약의 확정 채널과 비교해 안내를 띄우는 데 쓴다. null 은 기능 신설 이전 공고.",
          ),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 세모 안심결제 — 저장카드 결제 (승인 시 계약 성립)
 */
export const paymentControllerPayWithCardBodyCardQuotaMin = 0;
export const paymentControllerPayWithCardBodyCardQuotaMax = 12;

export const paymentControllerPayWithCardBody = zod
  .object({
    paymentCardId: zod.string().describe("결제에 사용할 카드 ID"),
    quoteResponseVersionId: zod.string().describe("결제할 견적 응답 버전 ID"),
    cardQuota: zod
      .number()
      .min(paymentControllerPayWithCardBodyCardQuotaMin)
      .max(paymentControllerPayWithCardBodyCardQuotaMax)
      .optional()
      .describe("할부 개월 수 (0=일시불, 2~12=할부)"),
    tempId: zod
      .string()
      .optional()
      .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
  })
  .strict();

/**
 * @summary 세모 안심결제 — 무통장 입금 요청 (입금 확인 후 계약)
 */
export const paymentControllerPayWithCashBody = zod
  .object({
    quoteResponseVersionId: zod.string().describe("결제할 견적 응답 버전 ID"),
    tempId: zod
      .string()
      .optional()
      .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
  })
  .strict();

/**
 * @summary 환불 신청 (승인 전까지 돈은 나가지 않음)
 */
export const paymentControllerRequestRefundParams = zod
  .object({
    paymentTransactionId: zod.coerce.string(),
  })
  .strict();

export const paymentControllerRequestRefundBodyRefundReasonMax = 500;

export const paymentControllerRequestRefundBody = zod
  .object({
    refundReason: zod
      .string()
      .max(paymentControllerRequestRefundBodyRefundReasonMax)
      .describe("환불 사유"),
    refundAmount: zod.number().describe("환불 금액 (단위: 원)"),
    refundBank: zod
      .string()
      .optional()
      .describe("환불 받을 은행명 (현금 결제 시 필수)"),
    refundAccountNumber: zod
      .string()
      .optional()
      .describe("환불 받을 계좌번호 (현금 결제 시 필수)"),
    refundAccountHolder: zod
      .string()
      .optional()
      .describe("환불 계좌 예금주 (현금 결제 시 필수)"),
  })
  .strict();

/**
 * @summary 업체 직접 결제 (플랫폼 외 결제, 자동 계약 생성)
 */
export const paymentControllerVendorDirectPayBody = zod
  .object({
    quoteResponseVersionId: zod
      .string()
      .describe("결제를 진행할 견적 응답 버전의 ID"),
    tempId: zod.string().optional().describe("낙관적 UI 매칭용 임시 ID"),
    paymentRoute: zod
      .enum(["OFFLINE", "CMARKET_CARD"])
      .optional()
      .describe(
        "대금 처리 경로. 미지정 시 OFFLINE(기존 동작) — 구버전 클라이언트 호환.",
      ),
    settlementChannel: zod
      .enum(["cash", "card"])
      .optional()
      .describe(
        "업체와 직접 정리하기로 한 방식(cash/card). **기록만 하는 값이다** — 세모가 이 결제를 실행하지 않는다. 실제 결제는 업체 단말기·결제 링크·계좌이체 등 시스템 밖에서 이뤄지고, 여기에 남긴 값은 나중에 「무엇으로 정리했는지」를 아는 근거다.\n\nOFFLINE 경로에서만 뜻이 있다. 미지정 시 cash(기존 동작).",
      ),
  })
  .strict();

/**
 * @summary 결제 내역 조회
 */
export const paymentControllerGetPaymentHistoryResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        transactions: zod
          .array(
            zod
              .object({
                id: zod.string().describe("결제 ID (MOID)"),
                type: zod
                  .enum(["CONTRACT", "SUBSCRIPTION"])
                  .describe("결제 타입 (CONTRACT | SUBSCRIPTION)"),
                paymentMethod: zod
                  .enum(["CARD", "CASH", "DIRECT"])
                  .describe("결제 수단"),
                quoteResponseVersionId: zod
                  .string()
                  .nullable()
                  .describe("견적 응답 버전 ID"),
                subscriptionId: zod
                  .string()
                  .nullable()
                  .describe("구독 ID (구독 결제인 경우)"),
                projectName: zod
                  .string()
                  .nullable()
                  .describe("프로젝트명 (견적 결제인 경우)"),
                supplierName: zod
                  .string()
                  .nullable()
                  .describe("공급자명 (업체명 또는 이름)"),
                amount: zod.number().describe("결제 금액"),
                status: zod
                  .enum([
                    "PENDING",
                    "APPROVED",
                    "REJECTED",
                    "FAILED",
                    "CANCELED",
                    "EXPIRED",
                  ])
                  .describe("결제 상태"),
                approvedAt: zod.string().nullable().describe("결제 승인 시간"),
                createdAt: zod.string().describe("결제 생성 시간"),
                paymentCardId: zod
                  .string()
                  .nullable()
                  .describe("카드 ID (결제에 사용된 카드) - 현금결제 시 null"),
                maskedCardNumber: zod
                  .string()
                  .nullable()
                  .describe("마스킹된 카드번호 - 현금결제 시 null"),
                tid: zod.string().nullable().describe("거래번호 (Innopay TID)"),
                refundId: zod
                  .string()
                  .nullable()
                  .describe("환불 ID (있을 경우)"),
              })
              .strict(),
          )
          .describe("결제 거래 내역"),
        refunds: zod
          .array(
            zod
              .object({
                id: zod.string().describe("환불 ID"),
                paymentTransactionId: zod.string().describe("결제 ID (MOID)"),
                status: zod
                  .enum([
                    "REQUESTED",
                    "APPROVED",
                    "REJECTED",
                    "PROCESSING",
                    "COMPLETED",
                    "FAILED",
                  ])
                  .describe("환불 상태"),
                refundAmount: zod.number().describe("환불 금액"),
                refundReason: zod.string().describe("환불 사유"),
                requestedAt: zod.string().describe("환불 요청 시간"),
                completedAt: zod.string().nullable().describe("환불 완료 시간"),
                errorMessage: zod
                  .string()
                  .nullable()
                  .describe("환불 실패 사유"),
              })
              .strict(),
          )
          .describe("환불 내역"),
        totalTransactions: zod.number().describe("총 결제 건수"),
        totalRefunds: zod.number().describe("총 환불 건수"),
        totalAmount: zod.number().describe("총 결제 금액"),
        totalRefundAmount: zod.number().describe("총 환불 금액"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 견적 응답에 대한 결제가 완료되면 구매자에게 결제 완료 알림을 발송합니다. 호출자는 해당 거래의 참여자(구매자 또는 공급자)여야 하며, 승인된 결제 건이 존재해야 합니다.
 * @summary 결제 완료 알림 발송
 */
export const paymentNotificationControllerNotifyPaymentCompleteBody = zod
  .object({
    quoteResponseVersionId: zod
      .string()
      .uuid()
      .describe("견적 응답 버전 ID (UUID)"),
    buyerId: zod.string().uuid().describe("구매자 ID (UUID)"),
    projectName: zod.string().describe("프로젝트명 (알림 메시지에 포함)"),
    amount: zod.number().describe("결제 금액 (KRW, 원)"),
  })
  .strict();

/**
 * 특정 견적 응답 버전에 대한 결제 트랜잭션 정보를 조회합니다.
 * @summary 결제 트랜잭션 조회
 */
export const paymentNotificationControllerGetTransactionParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const paymentNotificationControllerGetTransactionResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod
          .string()
          .describe("결제 트랜잭션 ID (MOID - Merchant Order ID)"),
        quoteResponseVersionId: zod
          .string()
          .uuid()
          .describe("견적 응답 버전 ID (UUID)"),
        paymentCardId: zod
          .string()
          .uuid()
          .nullable()
          .describe("결제 카드 ID (UUID)"),
        status: zod
          .enum([
            "PENDING",
            "APPROVED",
            "REJECTED",
            "FAILED",
            "CANCELED",
            "EXPIRED",
          ])
          .describe("결제 상태"),
        tid: zod.string().nullable().describe("PG 거래 번호 (Innopay 거래 ID)"),
        approvedAt: zod
          .string()
          .nullable()
          .describe("결제 승인 시각 (ISO 8601)"),
        errorCode: zod
          .string()
          .nullable()
          .describe("에러 코드 (Innopay API 에러 코드)"),
        errorMessage: zod
          .string()
          .nullable()
          .describe("에러 메시지 (Innopay API 에러 메시지)"),
        createdAt: zod.string().describe("생성 시각 (ISO 8601)"),
        updatedAt: zod.string().describe("수정 시각 (ISO 8601)"),
        userId: zod.string().uuid().describe("사용자 ID (UUID)"),
        refundId: zod.string().uuid().nullable().describe("환불 ID (UUID)"),
        paymentMethod: zod
          .enum(["CARD", "CASH", "DIRECT"])
          .describe("결제 수단 (CARD | CASH | DIRECT)"),
        expiresAt: zod
          .string()
          .nullable()
          .describe("결제 만료 시각 (ISO 8601)"),
        canceledAt: zod
          .string()
          .nullable()
          .describe("결제 취소 시각 (ISO 8601)"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * Innopay를 통해 신용카드를 등록하고 빌키를 발급받습니다
 * @summary 카드 등록
 */
export const paymentCardControllerRegisterCardBody = zod
  .object({
    cardNum: zod
      .string()
      .describe(
        "신용카드/체크카드 카드번호 13~19자리 (공백/하이픈 자동 제거, Luhn 체크섬 검증)",
      ),
    cardExpire: zod
      .string()
      .describe("카드 유효기간 (YYMM 형식, 예: 2512 = 2025년 12월)"),
    buyerName: zod.string().describe("등록자 이름"),
    idNum: zod
      .string()
      .describe(
        "카드인증 번호 (개인카드: 주민번호 앞 6자리, 법인카드: 사업자번호 10자리)",
      ),
    cardPwd: zod.string().describe("카드 비밀번호 앞 2자리"),
  })
  .strict();

/**
 * 등록된 활성 카드 목록을 조회합니다 (주 카드 먼저)
 * @summary 내 카드 목록 조회
 */
export const paymentCardControllerGetUserCardsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            id: zod.string().describe("카드 고유 식별자 (UUID)"),
            maskedCardNumber: zod
              .string()
              .describe("마스킹된 카드번호 (PCI-DSS 준수)"),
            cardCode: zod
              .string()
              .optional()
              .describe("카드사 코드 (01: 비씨, 02: 국민, 06: 신한 등)"),
            isPrimary: zod.boolean().describe("주 결제수단 여부"),
            registeredAt: zod.string().datetime({}).describe("카드 등록일시"),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 선택한 카드를 주 결제수단으로 설정합니다
 * @summary 주 결제수단 설정
 */
export const paymentCardControllerSetPrimaryCardParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

/**
 * 등록된 카드를 삭제하고 Innopay에서 빌키를 무효화합니다
 * @summary 카드 삭제
 */
export const paymentCardControllerDeleteCardParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

/**
 * @summary 구독 생성
 */
export const subscriptionControllerCreateSubscriptionBody = zod
  .object({
    planType: zod
      .enum(["FREE", "PRO", "ENTERPRISE", "TEST"])
      .describe("Subscription plan type"),
    paymentCardId: zod
      .string()
      .describe("Payment card ID (must be registered in payment module)"),
  })
  .strict();

/**
 * @summary 현재 구독 조회
 */
export const subscriptionControllerGetCurrentUserSubscriptionResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("Subscription ID"),
        buyerId: zod.string().describe("Buyer ID"),
        planType: zod
          .enum(["FREE", "PRO", "ENTERPRISE", "TEST"])
          .describe("Subscription plan type"),
        amount: zod.number().describe("Monthly subscription amount in KRW"),
        billingCycle: zod.enum(["MONTHLY"]).describe("Billing cycle"),
        nextPaymentDate: zod
          .string()
          .describe("Next payment date (YYYY-MM-DD)"),
        status: zod
          .enum(["ACTIVE", "CANCELED", "FAILED"])
          .describe("Subscription status"),
        createdAt: zod.string().describe("Created at timestamp"),
        updatedAt: zod.string().describe("Last updated at timestamp"),
        canceledAt: zod
          .string()
          .nullish()
          .describe("Canceled at timestamp (if canceled)"),
        cancellationReason: zod
          .string()
          .nullish()
          .describe("Cancellation reason (if provided)"),
        pendingPlanType: zod
          .enum(["FREE", "PRO", "ENTERPRISE", "TEST"])
          .nullish()
          .describe("Pending plan type (for scheduled plan changes)"),
        scheduledPlanChangeAt: zod
          .string()
          .nullish()
          .describe("Scheduled plan change date (YYYY-MM-DD)"),
        isPromotional: zod
          .boolean()
          .describe("Whether the subscription is currently under a promotion"),
        isTrial: zod
          .boolean()
          .describe(
            "Whether the subscription is a free trial (e.g. signup bonus)",
          ),
        promotionCode: zod
          .string()
          .nullish()
          .describe("Applied promotion code (if any)"),
        isPermanent: zod
          .boolean()
          .describe(
            "Whether this is a permanent subscription (no expiry, nextPaymentDate >= 2090)",
          ),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 구독 결제 내역 조회
 */
export const subscriptionControllerGetPaymentHistoryParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const subscriptionControllerGetPaymentHistoryResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            id: zod.string().describe("Payment record ID"),
            subscriptionId: zod.string().describe("Subscription ID"),
            amount: zod.number().describe("Payment amount in KRW"),
            status: zod
              .enum(["PENDING", "SUCCESS", "FAILED"])
              .describe("Payment status"),
            innopayTid: zod
              .string()
              .nullable()
              .describe("Innopay transaction ID (TID)"),
            errorMessage: zod
              .string()
              .nullable()
              .describe("Error message if payment failed"),
            paidAt: zod.string().nullable().describe("Paid at timestamp"),
            createdAt: zod.string().describe("Created at timestamp"),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 구독 플랜 변경
 */
export const subscriptionControllerChangeSubscriptionPlanParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const subscriptionControllerChangeSubscriptionPlanBody = zod
  .object({
    newPlanType: zod
      .enum(["FREE", "PRO", "ENTERPRISE", "TEST"])
      .describe("New subscription plan type"),
    paymentCardId: zod
      .string()
      .optional()
      .describe(
        "Payment card ID (required when upgrading from FREE to paid plan)",
      ),
  })
  .strict();

/**
 * @summary 구독 해지 (다운그레이드 예약)
 */
export const subscriptionControllerCancelSubscriptionParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const subscriptionControllerCancelSubscriptionBody = zod
  .object({
    reason: zod.string().optional().describe("구독 취소 사유"),
  })
  .strict();
